import { DeviceService } from 'src/app/services/device/device.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, UrlTree } from '@angular/router';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { LanguageService } from 'src/app/services/language/language.service';
import { CommonService } from 'src/app/services/common/common.service';
import { AppNotification } from 'src/app/data-models/common/app-notification.model';
import { TranslationNotification } from 'src/app/data-models/translation/translation';
import { Subscription, EMPTY } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
	selector: 'vtr-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
	private subscription: Subscription;
	private defaultRouteSubscription: Subscription;
	private redirectToUrl: string;
	showAnimation = true;

	constructor(
		public deviceService: DeviceService,
		private router: Router,
		private logger: LoggerService,
		private languageService: LanguageService,
		private commonService: CommonService,
		private route: ActivatedRoute,
		private configService: ConfigService
	) {
		this.route.queryParams.pipe(filter((params) => params.redirectTo)).subscribe((param) => {
			this.logger.debug('HomeComponent: redirect url', param);
			this.redirectToUrl = param.redirectTo;
		});
	}

	ngOnInit() {
		this.logger.info(`HomeComponent.ngOnInit`);
		try {
			this.subscription = this.commonService.notification.subscribe(
				(notification: AppNotification) => {
					this.onNotification(notification);
				}
			);

			if (this.deviceService.isShellAvailable) {
				const isLanguageLoaded = this.languageService.isLanguageLoaded;
				this.logger.info(`HomeComponent.ngOnInit is language loaded ${isLanguageLoaded}`);
				if (isLanguageLoaded) {
					this.redirectToPage();
				}
				if (!this.redirectToUrl && isLanguageLoaded) {
					this.redirectToDefaultPage();
				}
			} else {
				// for browser
				this.languageService.useLanguage();
				this.vantageLaunch();
			}
		} catch (error) {
			this.logger.error(`HomeComponent.ngOnInit`, error.message);
			return EMPTY;
		}
	}

	ngOnDestroy() {
		this.subscription?.unsubscribe();
		this.defaultRouteSubscription?.unsubscribe();
	}

	private vantageLaunch() {
		if (this.defaultRouteSubscription) return;
		this.defaultRouteSubscription = this.configService.defaultRouteSubject.subscribe(
			(route: UrlTree) => {
				if (route.toString() === '/') return;
				this.route.queryParams.subscribe((params) => {
					try {
						this.router.navigate([route.toString()], {
							queryParams: params,
						});
					} catch (error) {
						this.logger.error(`HomeComponent.vantageLaunch`, error.message);
						return EMPTY;
					}
				});
			}
		);
	}

	private onNotification(notification: AppNotification) {
		if (notification) {
			switch (notification.type) {
				case TranslationNotification.TranslationLoaded:
					if (this.redirectToUrl) {
						this.logger.info(
							`HomeComponent.onNotification redirecting to`,
							this.redirectToUrl
						);
						this.redirectToPage();
					} else {
						this.logger.info(`HomeComponent.onNotification`, notification);
						this.redirectToDefaultPage();
					}
					break;
				default:
					break;
			}
		}
	}

	private redirectToDefaultPage() {
		this.vantageLaunch();
	}

	private redirectToPage() {
		if (this.redirectToUrl) {
			window.history.replaceState([], '', '');
			this.router.navigateByUrl(this.redirectToUrl);
		}
	}
}
